import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-gtm-label"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 1,
  class: "show-multiple"
}
const _hoisted_4 = { class: "add-remove" }
const _hoisted_5 = {
  key: 2,
  class: "tile__item__splash"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tile__item__icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "select-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkboxComponent = _resolveComponent("checkboxComponent")!
  const _directive_epi_edit = _resolveDirective("epi-edit")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'tile__item tile__item--link tile__item__selectable',
			{ selected: _ctx.selected },
			{ disabled: _ctx.disabled },
			{ 'tile__item__selectable__multiple-container': _ctx.model.selectMultiple },
		]),
    "data-gtm-action": "tile click",
    "data-gtm-label": _ctx.model.title,
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
  }, [
    (_ctx.model.selectMultiple)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['amount', { amount__show: _ctx.multipleCount > 0 }])
        }, [
          _createElementVNode("span", {
            class: "txt font-family-work-sans-bold",
            textContent: _toDisplayString(_ctx.multipleCount)
          }, null, 8, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.model.selectMultiple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              id: "productPlus",
              class: _normalizeClass(['add-remove plus', { disabled: _ctx.multipleCount >= _ctx.model.selectMultipleMax }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
            }, null, 2),
            _createElementVNode("div", {
              id: "productMinus",
              class: _normalizeClass(['add-remove minus', { disabled: _ctx.multipleCount < 1 }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.model.splashTxt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "tile__item__splash__content",
            innerHTML: _ctx.model.splashTxt
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        class: "tile__item__icon__img",
        src: _ctx.model.icon.url,
        alt: ""
      }, null, 8, _hoisted_8)
    ]),
    _createElementVNode("div", {
      class: "tile__item__title tile__item__selectable__title",
      innerHTML: _ctx.model.title
    }, null, 8, _hoisted_9),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(), _createBlock(_component_checkboxComponent, {
        key: _ctx.updateCheckMark,
        id: _ctx.model.title,
        name: _ctx.model.title,
        preSelect: _ctx.selected,
        inputValue: "productSelect",
        class: "box--small"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["id", "name", "preSelect"]))
    ])
  ], 10, _hoisted_1)), [
    [_directive_epi_edit, 'SelectId']
  ])
}